/** Saved versions of a project (project_snapshot rows). */

export type VersionKind = 'manual' | 'review' | 'shared' | 'backup';

/** How a version is called in lists: "v3 · Client cut", "v3", or its name for unnumbered ones. */
export function versionLabel(v: { number: number; name: string }): string {
  if (!v.number) return v.name || 'Saved version';
  const tag = `v${v.number}`;
  return v.name && v.name !== tag ? `${tag} · ${v.name}` : tag;
}

/** The next version number for a project. */
export function nextVersionNumber(versions: Iterable<{ number: number }>): number {
  let max = 0;
  for (const v of versions) max = Math.max(max, v.number);
  return max + 1;
}
